<template>
	<div class="betslip">
		<div v-if="bets.length > 0" class="betslip__content">
			<bet
				v-for="bet in bets"
				:bet="bet"
				:key="bet.parent_virtual_id"
				:currentTime="currentTime"
			/>
		</div>
		<div v-else class="betslip-content--empty">
			You have no virtual bets in your betslip.
			<br />Kindly add some bets <br />
			<br />
			<router-link :to="'/virtual'" class="button button__secondary"
				>Go to virtual sports</router-link
			>
		</div>
		<div v-if="bets.length > 0" class="betslip__details">
			<div class="betslip__details__container">
				<div class="betslip__details__left">
					<div
						class="betslip__details__row"
						v-show="$store.getters.balance > 0 && loggedIn"
					>
						<span class="betslip__details__row__label">Wallet Balance</span>
						<span class="betslip__details__row__value bold">{{
							$store.getters.balance | currency
						}}</span>
					</div>

					<div class="betslip__details__row">
						<span
							class="betslip__details__row__label"
							style="flex-direction: column; align-items: flex-start"
						>
							<span>Total Odds</span>
							<small slot="desc">Min {{ env.minTotalOdd }} </small>
						</span>
						<div class="betslip__details__row__value bold">
							{{ totalOdds }}
						</div>
					</div>

					<div class="betslip__details__row">
						<span class="betslip__details__row__label">Amount</span>

						<input
							class="betslip__details__row__value input"
							type="number"
							name="amount"
							v-model="amount"
							:disabled="placingBet"
							min="1"
							step="1"
						/>
					</div>
					<div class="betslip__details__row">
						<span class="betslip__details__row__label">
							<span style="margin-right: 5px">Final Payout</span>

							<svg
								width="18"
								height="18"
								viewBox="0 0 10 11"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
								@click="infoOpen = !infoOpen"
							>
								<path
									d="M5 0.40625C5.85938 0.40625 6.67969 0.640625 7.42188 1.07031C8.16406 1.5 8.75 2.08594 9.17969 2.82812C9.60938 3.57031 9.84375 4.39062 9.84375 5.25C9.84375 6.12891 9.60938 6.92969 9.17969 7.67188C8.75 8.41406 8.16406 9.01953 7.42188 9.44922C6.67969 9.87891 5.85938 10.0938 5 10.0938C4.12109 10.0938 3.32031 9.87891 2.57812 9.44922C1.83594 9.01953 1.23047 8.41406 0.800781 7.67188C0.371094 6.92969 0.15625 6.12891 0.15625 5.25C0.15625 4.39062 0.371094 3.57031 0.800781 2.82812C1.23047 2.08594 1.83594 1.5 2.57812 1.07031C3.32031 0.640625 4.12109 0.40625 5 0.40625ZM5 2.55469C4.76562 2.55469 4.57031 2.65234 4.41406 2.80859C4.25781 2.96484 4.17969 3.16016 4.17969 3.375C4.17969 3.60938 4.25781 3.80469 4.41406 3.96094C4.57031 4.11719 4.76562 4.19531 5 4.19531C5.21484 4.19531 5.41016 4.11719 5.56641 3.96094C5.72266 3.80469 5.82031 3.60938 5.82031 3.375C5.82031 3.16016 5.72266 2.96484 5.56641 2.80859C5.41016 2.65234 5.21484 2.55469 5 2.55469ZM6.09375 7.51562V7.04688C6.09375 6.98828 6.05469 6.92969 6.01562 6.89062C5.97656 6.85156 5.91797 6.8125 5.85938 6.8125H5.625V4.85938C5.625 4.80078 5.58594 4.74219 5.54688 4.70312C5.50781 4.66406 5.44922 4.625 5.39062 4.625H4.14062C4.0625 4.625 4.00391 4.66406 3.96484 4.70312C3.92578 4.74219 3.90625 4.80078 3.90625 4.85938V5.32812C3.90625 5.40625 3.92578 5.46484 3.96484 5.50391C4.00391 5.54297 4.0625 5.5625 4.14062 5.5625H4.375V6.8125H4.14062C4.0625 6.8125 4.00391 6.85156 3.96484 6.89062C3.92578 6.92969 3.90625 6.98828 3.90625 7.04688V7.51562C3.90625 7.59375 3.92578 7.65234 3.96484 7.69141C4.00391 7.73047 4.0625 7.75 4.14062 7.75H5.85938C5.91797 7.75 5.97656 7.73047 6.01562 7.69141C6.05469 7.65234 6.09375 7.59375 6.09375 7.51562Z"
									fill="#60981A"
								/>
							</svg>

							<div class="info-popup" v-show="infoOpen && bets.length > 0">
								<div class="info-popup__row" v-show="env.exciseTax > 0">
									<span class="info-popup__row__label">Excise Tax</span>
									<span class="info-popup__row__value">{{
										(exciseTax || 0) | currency
									}}</span>
								</div>
								<div class="info-popup__row" v-show="env.exciseTax > 0">
									<span class="info-popup__row__label">Stake</span>
									<span class="info-popup__row__value">{{
										(amount - exciseTax || 0) | currency
									}}</span>
								</div>
								<div class="info-popup__row">
									<span class="info-popup__row__label">Win</span>
									<span class="info-popup__row__value">{{
										(possibleWinnings || 0) | currency
									}}</span>
								</div>
								<div class="info-popup__row" v-show="env.whtTax > 0">
									<span class="info-popup__row__label">Withholding Tax</span>
									<span class="info-popup__row__value">{{
										(tax || 0) | currency
									}}</span>
								</div>
							</div>
						</span>
						<span class="betslip__details__row__value">
							{{ (possiblePayout || 0) | currency }}</span
						>
					</div>
					<div class="betslip__details__buttons">
						<button
							id="placeBetButton"
							:amount="amount"
							:possibleWin="possibleWinnings"
							:totalOdds="totalOdds"
							:bonus="bonus"
							:points="points"
							:numberOfBets="bets.length"
							type="virtual"
							v-if="!areThereAnyInvalidMatches"
							class="betslip__details__button button button__primary full bold"
							@click="placeBet"
							:disabled="
								placingBet || amount < env.minimumBetAmount || isNaN(amount)
							"
						>
							<loader v-if="placingBet" />
							<span v-else>{{
								totalOdds < env.minTotalOdd
									? `Min total odds of ${env.minTotalOdd} required to place a bet`
									: "Place Bet"
							}}</span>
						</button>
						<button
							v-if="areThereAnyInvalidMatches"
							class="betslip__details__button button button__primary full bold"
							@click="$store.commit('removeInvalidBetsFromVirtualBetslip')"
						>
							Remove Expired
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Bet from "./VirtualBetslipBet.vue";
export default {
	name: "virtual-betslip",
	components: { Bet },
	data() {
		return {
			currentTime: +new Date(),
			maxPossibleWin: 1500000,
			placingBet: false,
			timerIntervalID: null,
			infoOpen: false,
		};
	},
	computed: {
		possiblePayout() {
			return Math.trunc((this.possibleWinnings - this.tax) * 100) / 100;
		},
		bets() {
			return this.$store.getters.virtualBetslip;
		},
		amount: {
			// getter
			get: function () {
				return this.$store.getters.stake;
			},
			// setter
			set: function (stake) {
				this.$store.commit("updateStake", parseFloat(stake));
			},
		},
		betAmount() {
			return this.amount;
		},
		totalOdds() {
			let oddValues = this.bets
				.filter((bet) => Number(bet.odd.odd_value) > 0)
				.map((bet) => Number(bet.odd.odd_value));

			return Math.trunc(oddValues.reduce((a, b) => a * b, 1) * 100) / 100;
			// return oddValues;
		},
		possibleWinnings() {
			if (isNaN(this.betAmount)) return 0;
			let possibleWin =
				Math.trunc(this.totalOdds * (this.betAmount - this.exciseTax) * 100) /
				100;
			return possibleWin > this.env.maximumVirtualsWin
				? this.env.maximumVirtualsWin
				: possibleWin;
		},
		exciseTax() {
			return (
				Math.round(
					(this.betAmount - this.betAmount / (1 + this.env.virtualsExciseTax)) *
						100
				) / 100
			);
		},
		tax() {
			let maxTax = this.possibleWinnings * this.env.virtualsWhtTax;
			let tax =
				Math.round(
					(this.possibleWinnings - (this.betAmount - this.exciseTax)) *
						this.env.virtualsWhtTax *
						100
				) / 100;
			if (tax < 0) return 0;
			return 0 || tax > maxTax ? maxTax : tax;
		},
		bonus() {
			// Give bonus to only those bets with odd values >= 1.6
			let validOdds = this.bets
				.filter((bet) => Number(bet.odd.odd_value) >= 1.6)
				.map((bet) => bet.odd.odd_value);

			let numberOfValidOdds = validOdds.length;
			let minimumCountToAwardBonus = 5;

			if (numberOfValidOdds < minimumCountToAwardBonus) return 0;
			if (numberOfValidOdds > 14) numberOfValidOdds = 14;

			let percentageBonusForCount = {
				5: 0.05,
				6: 0.06,
				7: 0.07,
				8: 0.08,
				9: 0.1,
				10: 0.1,
				11: 0.12,
				12: 0.2,
				13: 0.2,
				14: 0.2,
			};

			let bonus =
				percentageBonusForCount[numberOfValidOdds] * this.possibleWinnings;
			return bonus > this.maxBonus ? this.maxBonus : bonus;
		},
		points() {
			//  from 100 to 500 stake max points per bet is 50
			//  from 501 to 5000 stake max points per bet are 100
			//  from 5001 and above stake max points per bet are 200
			//  max points per day to be 500
			let points;
			if (this.totalOdds >= 9.99) {
				switch (true) {
					case this.amount < 49:
						points = 0;
						break;

					case this.amount >= 49 && this.amount < 100:
						points = (Number(this.amount) * Number(this.totalOdds)) / 100;
						points = points > 25 ? 25 : points;
						break;

					case this.amount >= 100 && this.amount < 501:
						points = (Number(this.amount) * Number(this.totalOdds)) / 100;
						points = points > 50 ? 50 : points;
						break;

					case this.amount > 500 && this.amount < 5001:
						points = (Number(this.amount) * Number(this.totalOdds)) / 100;
						points = points > 100 ? 100 : points;
						break;

					case this.amount > 5000:
						points = (Number(this.amount) * Number(this.totalOdds)) / 100;
						points = points > 200 ? 200 : points;
						break;

					default:
						points = 0;
						break;
				}
			} else {
				points = 0;
			}
			return points;
		},
		loggedIn() {
			return JSON.parse(window.localStorage.getItem("authenticated"));
		},
		areThereAnyInvalidMatches() {
			let vm = this;
			return false;
			return (
				this.bets.filter((bet) => {
					return +new Date(bet.start_time.replace(/-/g, "/")) < vm.currentTime;
				}).length > 0
			);
		},
		numberOfBets() {
			return this.bets.length;
		},
	},
	watch: {
		numberOfBets(n, o) {
			let vm = this;
			if (n == 1 && o == 0) {
				vm.$nextTick(() => {
					vm.adjustBetslipHeight();
				});
			}
		},
	},
	created() {
		this.updateCurrentTime();
	},
	beforeRouteLeave() {
		clearInterval(this.timerIntervalID);
	},
	mounted() {
		let vm = this;
		if (vm.$store.getters.layout == "Desktop" && bets.length > 0)
			vm.adjustBetslipHeight();
	},
	methods: {
		adjustBetslipHeight() {
			var desktopOffset = parseInt(
				getComputedStyle(document.body)
					.getPropertyValue("--desktop-header-offset")
					.trim()
					.replace("px", "")
			);
			var betslipDetailsHeight = document
				.querySelector(".betslip__details")
				.getBoundingClientRect().height;
			var padding = 20;
			var bottomOffset = 300;
			var betslipContentHeight = `${
				window.innerHeight -
				(desktopOffset + betslipDetailsHeight + padding + bottomOffset)
			}px`;
			document.querySelector(".betslip-content").style.maxHeight =
				betslipContentHeight;
			document.querySelector(".betslip-content").style.height = "auto";
			document.querySelector(".betslip-content").classList.add("adjusted");
		},
		clearBetslip() {
			this.$store.commit("clearVirtualBetslip");
		},
		updateCurrentTime() {
			let vm = this;
			vm.timerIntervalID = setInterval(() => {
				vm.currentTime = +new Date();
			}, 1000);
		},
		placeBet() {
			let vm = this;
			if (vm.bets.length == 0) return;
			vm.placingBet = true;
			// Check whether the user is authenticated
			if (!JSON.parse(window.localStorage.getItem("authenticated"))) {
				vm.$notifications.add({
					type: "warning",
					title: "Authentication required",
					message: "Please login first",
					duration: 3000,
				});
				vm.$router.replace("/login?next=/betslip?type=virtual");
				return;
			}

			let betslip = vm.bets.map((bet) => {
				return {
					sub_type_id: bet.odd.sub_type_id,
					special_bet_value: bet.odd.special_bet_value,
					bet_pick: bet.odd.odd_key,
					odd_value: bet.odd.odd_value,
					outcome_id: bet.odd.outcome_id,
					parent_virtual_id: bet.parent_virtual_id,
					parent_match_id: bet.parent_virtual_id,
					match_id: bet.parent_virtual_id,
					bet_type: 0,
				};
			});

			let payload = {
				bet_string: "MOBILE_WEB",
				app_name: "MOBILE_WEB",
				src: "MOBILE_WEB",
				possible_win: vm.possibleWinnings,
				profile_id: window.localStorage.getItem("user")
					? JSON.parse(window.localStorage.getItem("user")).id
					: "",
				stake: vm.amount,
				total_odd: vm.totalOdds,
				token: window.localStorage.getItem("token")
					? JSON.parse(window.localStorage.getItem("token"))
					: "",
				betslip: betslip,
				deviceID: "",
				endCustomerIP: "",
				channelID: "mobile",
				user_agent: localStorage.user_agent ? localStorage.user_agent : null,
				affiliate: localStorage.affiliate ? localStorage.affiliate : null,
			};

			vm.$tracking.bet.virtuals.start({
				no_of_bets: betslip.length,
				total_odds: vm.totalOdds,
				bet_amount: vm.amount,
				bet_type: "virtuals",
			});

			vm.$axios
				.post(`${LIVE_URL}virtual/placebet`, payload)
				.then((response) => {
					vm.placingBet = false;

					vm.$notifications.add({
						type: "success",
						title: "Bet placement successful",
						message: response.data.message,
						duration: 10000,
					});
					vm.$tracking.bet.virtuals.success({
						no_of_bets: betslip.length,
						total_odds: vm.totalOdds,
						bet_amount: vm.amount,
						bet_type: "virtuals",
						bet_id: response.data.bet_id,
						message: response.data.message,
						first_bet: response.data.first_bet == 1,
					});
					vm.$store.commit("SET_MYBETS_LAST_FETCH_TIME", null);
					if (!vm.keep) {
						vm.$store.commit("clearVirtualBetslip");
						vm.$router.push("/virtual");
					}
				})
				.catch((error) => {
					vm.placingBet = false;
					vm.$tracking.bet.virtuals.failed({
						no_of_bets: betslip.length,
						total_odds: vm.totalOdds,
						bet_amount: vm.amount,
						bet_type: "virtuals",
						message: error.response
							? error.response.data.message
							: error.message,
					});
					if (error.response && error.response.status == 401) {
						window.localStorage.setItem("authenticated", false);
						window.localStorage.removeItem("user");
						window.localStorage.removeItem("token");

						vm.$notifications.add({
							message: "Your session has expired. Please login again",
							title: "Session expired",
							type: "error",
							duration: 5000,
						});
						this.$router.replace("/login?next=/betslip?type=virtual");
						return;
					}
					vm.$notifications.add({
						type: "error",
						title: "Bet placement failed",
						message: error.response
							? error.response.data.message
							: "An error occurred. Please try again and contact us if this persists.",
						duration: 10000,
					});
				});
		},
	},
};
</script>
